import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTencentcloud = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 144 104",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	preserveAspectRatio: "xMidYMid",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		id: "style824",
		children: "\n	.tencent{fill:#00A1FF;}\n	.tencent1{fill:#00C4D6;}\n	.tencent2{fill:#006EFF;}\n"
	}), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "tencent",
			d: "m 134.3,47.5 c -6,-6.1 -14.3,-10 -23.6,-10 -8,0 -14.9,2.8 -21,7.7 -2.7,2.1 -5.4,4.6 -8.9,8 -1.8,1.6 -51.7,50.2 -51.7,50.2 2.7,0.4 6.2,0.4 9.5,0.5 3,0 60.5,0 62.9,0 4.8,0 8,0 11.4,-0.2 7.8,-0.6 15.1,-3.4 21,-9.2 13.1,-12.9 13.3,-33.9 0.4,-47 m -9.6,37.7 c -2.6,2.5 -7.1,5.4 -14.5,5.7 -3.5,0.1 -7.5,0.1 -9.4,0.1 H 60.7 C 75.2,76.9 88,64.5 89.4,63.1 c 1.3,-1.3 4.3,-4.1 6.9,-6.4 5.7,-5 10.7,-6.1 14.3,-6 5.6,0.1 10.7,2.4 14.4,6 7.8,7.9 7.7,20.7 -0.3,28.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "tencent1",
			d: "M 53.7,44.4 C 47.8,40 41.2,37.5 33.8,37.5 c -9.3,0 -17.6,3.8 -23.6,10 -12.8,13.1 -12.7,34.1 0.5,47 5.3,5.2 11.7,8 18.5,9 L 42,91 c -2.1,0 -5,-0.1 -7.7,-0.1 -7.5,-0.2 -12,-3.1 -14.5,-5.7 -8,-7.8 -8.2,-20.6 -0.4,-28.5 3.6,-3.7 8.8,-6 14.4,-6 3.5,0 8.3,1 13.7,5.5 2.6,2.1 8.3,7.2 10.8,9.4 0.1,0.1 0.3,0.1 0.4,0 l 8.9,-8.7 c 0.1,-0.1 0.1,-0.4 0,-0.4 C 63.3,52.4 57.3,47.1 53.7,44.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "tencent2",
			d: "M 114.2,30.1 C 108,12.8 91.5,0.4 72.2,0.4 c -22.3,0 -40.7,16.3 -44,37.5 1.8,-0.3 3.6,-0.4 5.5,-0.4 2.7,0 5.2,0.3 7.5,0.9 0.1,0 0.1,0 0.1,0 3,-14.3 15.7,-25 30.8,-25 12.6,0 23.6,7.6 28.6,18.3 0.1,0.1 0.2,0.2 0.4,0.2 3.8,-1 8.2,-1.6 12.6,-1.3 0.4,0.1 0.5,-0.1 0.5,-0.5"
		})
	] })]
});
export default SvgTencentcloud;
